// extracted by mini-css-extract-plugin
export default {"parameter":"oMnsx","name":"ZoXNT","count":"AbB8s"};